import * as React from 'react';
import { DoubleInput, InputAdornment, UIHeading4 } from '@cian/ui-kit';

import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { kitchenAreaInputDescriptors } from '../../constants/descriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { debounce } from '@cian/newbuilding-utils';
import { DEFAULT_INPUT_TIMEOUT } from '../../constants/timeouts';

export interface IKitchenAreaInputsProps extends IDescriptorProps<number> {
  getOffersCount(): void;
  updateTags(): void;
}

class KitchenAreaInputsComponent extends React.Component<IKitchenAreaInputsProps> {
  public getOffersCount = debounce(DEFAULT_INPUT_TIMEOUT, this.props.getOffersCount);

  public shouldComponentUpdate(nextProps: IKitchenAreaInputsProps) {
    const { gte: nextGte, lte: nextLte } = this.getValue(nextProps);
    const { gte, lte } = this.getValue(this.props);

    return nextGte !== gte || nextLte !== lte;
  }

  public getValue = ({ jsonQuery: { kitchen_area } }: IKitchenAreaInputsProps) => {
    const gte = kitchen_area && kitchen_area.value ? kitchen_area.value.gte : undefined;
    const lte = kitchen_area && kitchen_area.value ? kitchen_area.value.lte : undefined;

    return { gte, lte };
  };

  public render() {
    const { actionCreator, descriptors } = this.props;
    const { gte, lte } = this.getValue(this.props);
    const action = (type: 'gte' | 'lte') => (value: number | undefined) => {
      actionCreator(descriptors[0])(value, type);
      this.props.updateTags();
      this.getOffersCount();
    };

    return (
      <DoubleInput
        label={<UIHeading4>Кухня</UIHeading4>}
        dataTestId="inputs-multiple"
        onChangeFrom={action('gte')}
        onChangeTo={action('lte')}
        fromAdornments={{ left: <InputAdornment>от</InputAdornment>, right: <InputAdornment>м²</InputAdornment> }}
        toAdornments={{ left: <InputAdornment>до</InputAdornment>, right: <InputAdornment>м²</InputAdornment> }}
        value={[gte, lte]}
        ariaLabel={['Минимальная площадь кухни', 'Максимальная площадь кухни']}
      />
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    updateTags: () => {
      dispatch(updateTags());
    },
  };
}

export const KitchenAreaInput = connectToDescriptors(
  kitchenAreaInputDescriptors,
  mapDispatchToProps,
)(KitchenAreaInputsComponent);
